import TextAndForm from "./TextAndForm";
import TextAndFormSub from "./TextAndFormSub";
import HeadLine from "./HeadLine";
import ImageLeftRight from "./ImageLeftRight";
import Icons from "./Icons";
import ImageAndText from "./ImageAndText";
import ListImage from "./ListImage";

export default function PageRenderer({ blocks }) {
  return (
    <div>
      {blocks.map((block, index) => {
        switch (block.type) {
          case "textandform":
            return <TextAndForm key={index} {...block} />;
          case "textandformsub":
            return <TextAndFormSub key={index} {...block} />;
          case "headline":
            return <HeadLine key={index} {...block} />;
          case "imageleftright":
            return <ImageLeftRight key={index} {...block} />;
          case "icons":
            return <Icons key={index} {...block} />;
          case "imageandtext":
            return <ImageAndText key={index} {...block} />;
          case "listimage":
            return <ListImage key={index} {...block} />;
          default:
            return null;
        }
      })}
    </div>
  );
}
